import React from "react"
import { Col, Container, ListGroup, ListGroupItem, Row } from "shards-react"
import Image from "../components/image"
import Banner from "../containers/Banner"
import Layout from "../containers/Layout"
import Navbar from "../containers/Navbar"
import SEO from "../containers/Seo"
import CallToAction from "../containers/CallToAction"

export default function BeneficiosPage() {
  return (
    <Layout>
      <SEO title="Samus  - Educación Colaborativa | Producto" />
      <Banner>
        <Navbar />
        <Row
          data-sal="slide-up"
          data-sal-delay="150"
          data-sal-easing="ease"
          className="pt-4"
        >
          <Col xs={12} sm={6} className="px-5">
            <h1 className="text-white main-text">
              <b>Se parte de la innovación</b>
            </h1>
            <p className="mt-4 mb-2 text-white">
              <b> Samus </b>es el sistema de administración escolar dominicano
              más innovador del país. Haciendo uso de las mejores tecnologías,
              la seguridad digital, y servicios en la nube.
            </p>
            <p className="text-white">
              Podremos hacer que el rendimiento de su institución y la calidad
              de la educación entregada crezca de manera exponencial.
            </p>
          </Col>
          <Col xs={12} sm={6} className="text-white p-5">
            <Image file="dashboard_img.png" />
          </Col>
        </Row>
      </Banner>
      <Container fluid>
        <Row
          data-sal="slide-up"
          data-sal-delay="300"
          data-sal-easing="ease"
          className="call-to-action"
        >
          <Col>
            <h3>Caracteristica del sistema</h3>
            <p className="m-0">
              Estas son los módulos más destacados del sistema.
            </p>
          </Col>
        </Row>
        <br />
        <section className="mx-3 mb-3 pt-5">
          <Row
            data-sal="slide-up"
            data-sal-delay="300"
            data-sal-easing="ease"
            className="m-5"
          >
            <Col>
              <h3 className="product-title">Facturación y Reportes</h3>
              <p className="m-0">
                Maneje con seguridad y rapidez los pagos y facturas realizados.
                Simplificando de manera significativa los procedimientos
                contables y agilizando el <b>proceso de pago</b>.
              </p>
              <br />
              <p className="m-0">
                Tenga la facilidad de obtener <b>reportes</b> y{" "}
                <b>analíticas en real-time</b> para tener una base con la cual
                tomar decisiones importantes.
              </p>
              <br />
              <ListGroup flush>
                <ListGroupItem>Impresión de facturas</ListGroupItem>
                <ListGroupItem>Reportes financieros</ListGroupItem>
                <ListGroupItem>Gráficos en el Dashboard</ListGroupItem>
              </ListGroup>
            </Col>
            <Col className="d-none d-sm-block">
              <DobleImage duplex={["dashboard.png", "billing.png"]} />
            </Col>
          </Row>

          <Row
            data-sal="slide-up"
            data-sal-delay="300"
            data-sal-easing="ease"
            className="m-5"
          >
            <Col className="d-none d-sm-block">
              <DobleImage duplex={["student-list.png", "student-detail.png"]} />
            </Col>
            <Col>
              <h3 className="product-title">
                Gestión de Estudiantes y Profesores{" "}
              </h3>
              <p className="m-0">
                Gestione los datos de sus{" "}
                <b>alumnos, familiares y profesores</b>, donde podremos
                almacenar toda la información personal e históricos.
              </p>
              <br />
              <ListGroup flush>
                <ListGroupItem>Datos de estudiante</ListGroupItem>
                <ListGroupItem>Histórico de estudiante</ListGroupItem>
                <ListGroupItem>Datos del docente</ListGroupItem>
              </ListGroup>
            </Col>
          </Row>

          <Row
            data-sal="slide-up"
            data-sal-delay="300"
            data-sal-easing="ease"
            className="m-5"
          >
            <Col>
              <h3 className="product-title">Configuración Personalizable</h3>

              <p className="m-0">
                La configuración del sistema está preparada para{" "}
                <b>adaptarse</b> a cualquier tipo de modelo implementado en su
                institución.
              </p>
              <br />
              <p className="m-0">
                Bajo una interfaz amigable podrá personalizar las condiciones
                del sistema.
              </p>
              <br />
              <ListGroup flush>
                <ListGroupItem>Configuración de datos escolares</ListGroupItem>
                <ListGroupItem>
                  Personalización de notas, cursos, asignaturas
                </ListGroupItem>
                <ListGroupItem>Manejo de staff institucional</ListGroupItem>
              </ListGroup>
            </Col>
            <Col className="d-none d-sm-block">
              <DobleImage duplex={["dashboard.png", "settings.png"]} />
            </Col>
          </Row>

          <Row
            data-sal="slide-up"
            data-sal-delay="300"
            data-sal-easing="ease"
            className="m-5"
          >
            <Col className="d-none d-sm-block">
              <DobleImage duplex={["course-detail.png", "gradebook.png"]} />
            </Col>
            <Col>
              <h3 className="product-title">Asistencia y Notas</h3>
              <p className="m-0">
                Manténgase al tanto del <b> registro de notas</b> de cada
                estudiante y su <b>asistencia</b>,
              </p>
              <p className="m-0">
                de esta manera podremos dar seguimiento a los alumnos que
                presentan dificultades.
              </p>
              <br />
              <ListGroup flush>
                <ListGroupItem>Récord de Asistencia</ListGroupItem>
                <ListGroupItem>Récord de notas</ListGroupItem>
              </ListGroup>
            </Col>
          </Row>

          <Row
            data-sal="slide-up"
            data-sal-delay="300"
            data-sal-easing="ease"
            className="m-5"
          >
            <Col>
              <h3 className="product-title">Comunicación y Coolaboración</h3>
              <p className="m-0">
                Con un canal directo entre docentes, administrativos y
                familiares, podremos lograr un gran impacto en la educación del
                estudiante.
              </p>
              <br />
              <ListGroup flush>
                <ListGroupItem>Comunicaciones a los familiares</ListGroupItem>
                <ListGroupItem>Observaciones a estudiantes</ListGroupItem>
                <ListGroupItem>Consulta por parte de tutores</ListGroupItem>
              </ListGroup>
            </Col>
            <Col className="d-none d-sm-block">
              <DobleImage duplex={["list.png", "calendar.png"]} />
            </Col>
          </Row>

          <Row
            data-sal="slide-up"
            data-sal-delay="300"
            data-sal-easing="ease"
            className="m-5"
          >
            <Col className="d-none d-sm-block">
              <DobleImage duplex={["dashboard.png", "support.jpg"]} />
            </Col>
            <Col>
              <h3 className="product-title">Sporte y Actualización</h3>
              <p className="m-0">
                Estamos comprometidos con cada día{" "}
                <b>mejorar toda la experiencia</b> en el uso del Sistema.
              </p>
              <p className="m-0">
                El sistema cuenta con{" "}
                <b>
                  soporte y actualizaciones incluidas sin ningún cargo adicional
                </b>
                .
              </p>
              <br />
              <ListGroup flush>
                <ListGroupItem>Actualización constante</ListGroupItem>
                <ListGroupItem>Soporte de manera rápida</ListGroupItem>
                <ListGroupItem>Nuevos módulos libre de cargos</ListGroupItem>
              </ListGroup>
            </Col>
          </Row>
          <br />
        </section>
      </Container>

      <CallToAction />
    </Layout>
  )
}

function DobleImage({ duplex: [i1, i2] }) {
  return (
    <div>
      <Image file={i1} className="doble-img-1" />
      <Image file={i2} className="doble-img-2" />
    </div>
  )
}
